import React from 'react';
import styles from './fncSubtitle.module.scss';

interface SubTitleProps {
  children?: string;
}
const SubTitle: React.FC<SubTitleProps> = ({ children }) => <h2 className={`${styles.root}`}>{children}</h2>;

export default SubTitle;
